import React, { useState, useEffect, useCallback } from 'react';
import { useProdutosStore } from '../../store/ProdutosStore';
import { Paper, Typography, Box, Stack, Pagination } from '@mui/material';

// Importando os componentes filhos
import FiltrosBusca from '../../components/FiltroBuscaDeMaquinas';
import TabelaProdutos from '../../components/TabelaProdutos';
import ModalEdicaoProdutos from '../../components/ModalEdicaoProdutos';
import ModalCriacaoDeProdutos from '../../components/ModalCriacaoDeProdutos';
import FiltrosBuscaProdutos from '../../components/FiltrosDeBuscaPordutos'
import ConfirmDeleteModal from '../../components/ModalDeConfirmacao';

export default function ProdutosPage() {

    const {
        produtos,
        pagina_atual,
        ultima_pagina,
        GetProdutos,
        carregando,
        fetchProdutos,
        searchProdutos,
        updateProdutos,
        CreateProduto,
        deleteProduto,
        deletingId,
        fetchGruposEsubgrupos,
        grupos,
        sub_grupos,
        erro_no_codigo_de_consulta,
        setFiltroDeBusca,
        seterroCodigoConsultaProduto,
    } = useProdutosStore();

    // Estado local para controlar o modal de edição
    const [modalAberto, setModalAberto] = useState(false);
    const [modalCriacaoAberto, setmodalCriacaoAberto] = useState(false);
    const [produtoSelecionado, setProdutoSelecionado] = useState(null);
    const [ModalConfirmacao, setModalConfirmacao] = useState(false);
    const [msgModalConfirmacao, setMsgModalConfirmacao] = useState('');

    // Busca inicial dos dados quando o componente é montado
    useEffect(() => {
        fetchProdutos();
    }, [fetchProdutos]);

    useEffect(() => {
        fetchGruposEsubgrupos();
    }, []);

    // Funções de callback otimizadas com useCallback
    const handleBusca = useCallback((filtros) => {
        setFiltroDeBusca(filtros);
        searchProdutos(filtros);
    }, [searchProdutos]);

    const handleLimparBusca = useCallback(() => {
        fetchProdutos(1); // Volta para a primeira página ao limpar
    }, [fetchProdutos]);

    const handleAbrirModal = useCallback((produto) => {
        setProdutoSelecionado(produto);
        setModalAberto(true);
    }, []);

    const handleAbrirModalConfirmacao = useCallback(() => {
        setModalConfirmacao(true)
    }, []);

    const handleFecharModalConfirmacao = useCallback(() => {
        setModalConfirmacao(false)
    }, []);

    const handleFecharModal = useCallback(() => {
        setModalAberto(false);
        setProdutoSelecionado(null);
    }, []);

    const handleFecharModalCriacao = useCallback(() => {
        setmodalCriacaoAberto(false);
        seterroCodigoConsultaProduto(false);
    }, [])

    const handleAbrirModalCriacao = useCallback(() => {
        setmodalCriacaoAberto(true);
    }, [])

    const handleSalvarEdicao = useCallback(async (dadosProdutos) => {
        let resposta = await updateProdutos(dadosProdutos);
        if (!resposta) return;
        handleFecharModal();
        setFiltroDeBusca(null);

    },);

    const handleSalvarCriacao = useCallback(async (dadosProdutos) => {
        let resposta = await CreateProduto(dadosProdutos);

        if (erro_no_codigo_de_consulta) {
            return;
        };

        if (resposta) {
            handleFecharModalCriacao();
            return;
        };

    }, [CreateProduto, handleFecharModalCriacao]);

    const handleExcluir = useCallback((produto) => {
        handleAbrirModalConfirmacao();
        setMsgModalConfirmacao('Deseja realmente excluir este produto?');
        setProdutoSelecionado(produto);
    }, [deleteProduto]);

    const handleConfirmarExlusao = useCallback((produto) => {
        handleFecharModalConfirmacao();
        setMsgModalConfirmacao('');
        deleteProduto(produto);
    }, []);




    const handlePageChange = useCallback((event, page) => {
        fetchProdutos(page);
    }, [fetchProdutos]);

    return (
        <Paper elevation={3} sx={{ p: 3, borderRadius: 3, width: '100%', }}>
            <Typography variant="h5" component="h1" gutterBottom>
                Gerenciamento de Produtos
            </Typography>

            <FiltrosBuscaProdutos
                onSearch={handleBusca}
                onClear={handleLimparBusca}
                oncreate={handleAbrirModalCriacao}
                grupos={grupos}
                sub_grupos={sub_grupos}

            />

            <Box sx={{ mt: 4 }}>
                <TabelaProdutos
                    produtos={produtos}
                    onEdit={handleAbrirModal}
                    onDelete={handleExcluir}
                    loadingState={{ carregando, deletingId }}
                />
            </Box>

            <Stack spacing={2} sx={{ mt: 3, alignItems: 'center' }}>
                <Pagination
                    page={pagina_atual}
                    count={ultima_pagina}
                    onChange={handlePageChange}
                    color="primary"
                    shape="rounded"
                    disabled={carregando !== 'idle'}
                />
            </Stack>

            {/* MODAL DE EDIÇÃO */}
            {modalAberto && (
                <ModalEdicaoProdutos
                    open={modalAberto}
                    onClose={handleFecharModal}
                    onSave={handleSalvarEdicao}
                    produto={produtoSelecionado}
                    grupos={grupos}
                    sub_grupos={sub_grupos}
                    isLoading={carregando === 'updating'}
                />
            )}

            {/* MODAL DE CRIACAO */}
            {modalCriacaoAberto && (
                <ModalCriacaoDeProdutos
                    open={modalCriacaoAberto}
                    onSave={handleSalvarCriacao}
                    produto={produtoSelecionado}
                    onClose={handleFecharModalCriacao}
                    grupos={grupos}
                    sub_grupos={sub_grupos}
                    isLoading={carregando === 'creating'}
                    codigo_de_consulta_ja_existe={erro_no_codigo_de_consulta}

                />
            )}

            {
                ModalConfirmacao && (
                    <ConfirmDeleteModal
                        mensagem={msgModalConfirmacao}
                        open={ModalConfirmacao}
                        onClose={handleFecharModalConfirmacao}
                        titulo={'Atenção'}
                        onConfirm={() => { handleConfirmarExlusao(produtoSelecionado) }}
                    />
                )
            }
        </Paper>
    );
}